<template>
  <resource-base
    :loading-display="false"
    :is-management-mode="isManagementMode"
  >
    <template v-slot:display>
      <b-row>
        <b-col>
          <display
            :publishing="publishing"
            :resource="resource"
            :is-management-mode="isManagementMode"
          />
        </b-col>
      </b-row>
    </template>
    <template v-slot:activity>
      <activity :resource="resource" />
    </template>
    <template v-slot:settings>
      <settings :publishing="publishing" :resource="resource" />
    </template>
  </resource-base>
</template>
<script>
import ResourceBase from "../resourceBase";
import Display from "./sections/display";
import Activity from "./sections/activity";

import Settings from "./sections/settings";
export default {
  name: "ResourcePages",
  components: {
    ResourceBase,
    Display,
    Activity,
    Settings
  },
  props: {
    resource: {
      type: Object,
      required: false,
      default: () => {}
    },
    publishing: {
      type: Object,
      required: false,
      default: () => {}
    },
    isManagementMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      title: this.resource.name,
      imgURL: this.resource.imgURL,
      faIcon: this.resource.icon ? this.resource.icon : "fa-folder"
    };
  },
  methods: {
    showResource() {
      this.show = true;
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
img {
  cursor: pointer;
}

.video {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.youtube-player {
  border: 1px solid #1d740c;
  height: 390px;
  width: 480px;
  padding: 0px;
  margin-left: 25px;
  margin-bottom: 25px;
}
</style>
